var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-content',[_c('div',{staticClass:"bg-white shadow-sm rounded p-4"},[_c('settlement-form',{attrs:{"form_data":_vm.form_data,"password":_vm.password,"form_meta_data":_vm.form_meta_data,"on_submit":_vm.sendCode},on:{"settlement":_vm.settlement}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }